import { FC } from "react";
import IMAGES from "../../../../Img/index";
import { PropsCaptionBar } from "../../../modelsMessageBox";

import "./MessageBoxCaptionBar.scss";

const MessageBoxCaptionBar: FC<PropsCaptionBar> = ({
    handleClose,
    captionButtons,
}) => {
    const buttons = captionButtons?.captionButtons ?? [
        {
            id: "CAPTION_CLOSE",
            role: "close",
            icon: "close",
            // onClick: (event: any) => {
            //     handleClose("no");
            // },
        },
    ];

    return (
        <div className="message_box_caption_bar">
            <div></div>
            <div className="message_box_caption_bar__buttons">
                {!captionButtons?.hideCaptionButtons &&
                    buttons.map(({ id, icon, role }) => {
                        return (
                            <button
                                key={id}
                                // id={id}
                                id="CAPTION_CLOSE"
                                role={role}
                                className="message_box_caption_bar__action_button"
                                // onClick={(event) => {
                                //     onClick(event);
                                // }}
                            >
                                <img
                                    src={IMAGES[icon]}
                                    alt="caption action button"
                                />
                            </button>
                        );
                    })}
            </div>
        </div>
    );
};

export default MessageBoxCaptionBar;
